import 'angular:locale/data:zh';
import 'angular:locale/data:pt';
import 'angular:locale/data:ja';
import 'angular:locale/data:en';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
